import { UliActivityType } from '../../../../../common/constants';
import { LocalDate, LocalDateRangeModel } from '../../../../models';

export enum BookingHistoryActionType {
  Allocated = 'TIMESLOT_ALLOCATED',
  Updated = 'TIMESLOT_UPDATED',
  Deleted = 'TIMESLOT_DELETED',
}

export class BookingHistoryItem {
  actionDate: LocalDate;
  actionInitiator: string;
  actionType: BookingHistoryActionType;
  timeSlot: LocalDateRangeModel;
  compartmentName: string;
  dockName: string;
  hubName: string;
  ruleName: string;
  ruleId: string;
  uli: string;
  uliType: UliActivityType;
}

export class BookingHistoryCriteria {
  compartmentId: number;
  uli: string;
  uliType: UliActivityType;
}

export class BookingHistoryStateModel {
  items: BookingHistoryItem[];
  loaded: boolean;
}

export class BookingHistoryConfirmationResponseModel {
  data: Blob;
  fileName: string;

  constructor(params?: BookingHistoryConfirmationResponseModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
